import ChartContainer from '@erkport/components/AppChartContainer';
import React from 'react';
import {drawChart} from './chart';

type Last12MonthsChartType = {
  containerName: string;
  data: {current: any[]; prev: any[]};
  legends: string[];
  height?: number;
};

const Last12MonthsChart: React.FC<Last12MonthsChartType> = ({
  containerName,
  data,
  legends,
  height,
}) => {
  return (
    <ChartContainer
      containerName={containerName}
      drawChart={(_container, _data) => drawChart(_container, _data, legends)}
      data={data}
      height={height}
    />
  );
};

export default Last12MonthsChart;
